import { useState, useEffect } from "react";

function CircuitLine() {
  const c = "rgba(255,255,255,0.07)";
  return (
    <svg style={{ position:"absolute", top:0, right:0, width:"340px", height:"100%", pointerEvents:"none", overflow:"visible" }} viewBox="0 0 340 130" fill="none">
      <line x1="340" y1="18" x2="230" y2="18" stroke={c} strokeWidth="1"/>
      <circle cx="230" cy="18" r="2.5" fill={c}/>
      <line x1="230" y1="18" x2="230" y2="65" stroke={c} strokeWidth="1"/>
      <line x1="230" y1="65" x2="300" y2="65" stroke={c} strokeWidth="1"/>
      <circle cx="300" cy="65" r="2" fill={c}/>
      <line x1="300" y1="65" x2="300" y2="110" stroke={c} strokeWidth="1"/>
      <line x1="170" y1="0"  x2="170" y2="38"  stroke={c} strokeWidth="0.7"/>
      <line x1="170" y1="38" x2="200" y2="38"  stroke={c} strokeWidth="0.7"/>
      <circle cx="200" cy="38" r="1.5" fill={c}/>
      <line x1="320" y1="88" x2="255" y2="88"  stroke={c} strokeWidth="0.7"/>
      <circle cx="255" cy="88" r="1.5" fill={c}/>
    </svg>
  );
}

export default function HomeKPIs({ usuario, oscuro, onModulo }) {
  const [hora, setHora] = useState(new Date());

  useEffect(() => {
    const iv = setInterval(() => setHora(new Date()), 1000);
    return () => clearInterval(iv);
  }, []);

  const saludo = () => {
    const h = hora.getHours();
    if (h < 12) return "Buenos días";
    if (h < 19) return "Buenas tardes";
    return "Buenas noches";
  };

  const horaStr    = hora.toLocaleTimeString("es-AR", { hour:"2-digit", minute:"2-digit" });
  const segundos   = hora.toLocaleTimeString("es-AR", { second:"2-digit" }).split(":")[2] || "00";
  const fechaStr   = hora.toLocaleDateString("es-AR", { weekday:"long", day:"numeric", month:"long" });

  return (
    <div style={{ fontFamily:"Inter,sans-serif", padding:"1.2rem 1.5rem 0" }}>
      <div style={{
        position:"relative", overflow:"hidden",
        background:"linear-gradient(135deg, #1C3FAA 0%, #2A7FFF 100%)",
        borderRadius:"18px", padding:"1.6rem 2rem",
        marginBottom:"1.2rem",
        boxShadow:"0 6px 28px rgba(28,63,170,0.28)",
      }}>
        <CircuitLine/>
        <div style={{ position:"relative", zIndex:1, display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:"12px" }}>

          {/* IZQUIERDA — saludo */}
          <div>
            <p style={{
              fontSize:"9px", letterSpacing:".28em", textTransform:"uppercase",
              color:"rgba(255,255,255,0.4)", margin:"0 0 4px", fontWeight:"600"
            }}>
              {fechaStr}
            </p>
            <h2 style={{
              fontSize:"22px", fontWeight:"700", color:"white",
              margin:"0 0 4px", fontFamily:"Montserrat,sans-serif"
            }}>
              {saludo()}, {usuario.nombre}
            </h2>
            <p style={{ fontSize:"11px", color:"rgba(255,255,255,0.45)", margin:"0 0 2px" }}>
              {usuario.rol} · ALQOS™
            </p>
            {usuario.empresa && (
              <p style={{
                fontSize:"10px", color:"rgba(255,255,255,0.28)",
                margin:0, letterSpacing:".05em", fontStyle:"italic"
              }}>
                {usuario.empresa}
              </p>
            )}
          </div>

          {/* DERECHA — reloj */}
          <div style={{ textAlign:"right" }}>
            <p style={{
              fontSize:"38px", fontWeight:"800", color:"white",
              margin:0, fontFamily:"Montserrat,sans-serif",
              letterSpacing:".02em", lineHeight:1
            }}>
              {horaStr}
            </p>
            <p style={{
              fontSize:"9px", color:"rgba(255,255,255,0.3)",
              margin:"4px 0 0", letterSpacing:".12em",
              fontFamily:"'DM Mono', monospace"
            }}>
              :{segundos} · sync activo
            </p>
          </div>

        </div>

        {/* PIE */}
        <p style={{
          fontSize:"8.5px", color:"rgba(255,255,255,0.15)",
          margin:"14px 0 0", textAlign:"right",
          letterSpacing:".12em", fontFamily:"Montserrat,sans-serif",
          position:"relative", zIndex:1
        }}>
          ALQOS™ · SISTEMA DE GESTIÓN INTEGRAL · by AS · QORVEX
        </p>

      </div>
    </div>
  );
}